import { gql } from '@apollo/client';

export default gql`
  query inspectionReport($id: ID!) {
    inspectionReport(id: $id) {
      contentBase64
      filename
      mimeType
    }
  }
`;
